import { useRegionParameters } from '../../contents';
import { formatAnswer } from '../modules/statements/answers';

type UseStudentAnswer = {
  answer: string | undefined;
  isLoading: boolean;
};

function useStudentAnswer({ answer }: { answer: string }): UseStudentAnswer {
  const { regionParameters, isLoading } = useRegionParameters({});

  return {
    isLoading,
    answer: formatAnswer(answer, regionParameters),
  };
}

export { useStudentAnswer };
